import { render } from "./GuardianList.vue?vue&type=template&id=30d3c15b&scoped=true&ts=true"
import script from "./GuardianList.vue?vue&type=script&lang=ts"
export * from "./GuardianList.vue?vue&type=script&lang=ts"

import "./GuardianList.vue?vue&type=style&index=0&id=30d3c15b&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d3c15b"]])

export default __exports__